
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { SimpleModalService } from '@looorent/ngx-simple-modal';
import { UnsavedchangesdialogComponent } from '../modals/unsavedchangesdialog/unsavedchangesdialog.component';

export interface ComponentCanDeactivate {
  CanDeactivate: () => boolean | Observable<boolean>;
}

@Injectable()
export class PendingChangesGuard  {
    
    constructor(private modalService : SimpleModalService){
          
    }
  canDeactivate(component: ComponentCanDeactivate): boolean | Observable<boolean> {
    
    if(component.CanDeactivate()){
        return true;
    }
    return this.modalService.addModal(UnsavedchangesdialogComponent, { }, { draggable : false});
  }
}
